<template>
  <div class="page-container">
    <div class="account-card">
      <span class="page-title">個人帳號</span>
      <div class="card-content">
        <div class="header">
          <div class="user-info">
            <h3>{{ user.last_name + user.first_name }}</h3>
            <p>{{ user.email }}</p>
          </div>
          <div class="buttons">
            <a-button @click="onDelete" ghost danger>刪除</a-button>
            <a-button @click="onSuspend" type="primary" ghost>{{ user.is_active ? "停權" : "復權" }}</a-button>
            <a-button @click="onEdit" type="primary" ghost>編輯</a-button>
          </div>
        </div>
        <hr/>
        <div class="details">
          <div class="detail-row">
            <div>權限：<span>{{ $t(`roles.${user.role}`) }}</span></div>
            <div>公司：<span>{{ user.organization?.name || "無" }}</span></div>
          </div>
          <div class="detail-row">
            <div>狀態：<span>{{ user.is_active ? "正常" : "停權" }}</span></div>
            <div>註冊日期：<span>{{ formatDate(new Date(user.date_joined)) }}</span></div>
          </div>
          <div class="detail-row">
            <div>最後登入：<span>{{ formatDate(new Date(user.last_login)) }}</span></div>
            <div v-if="user.logout_time">登出時間：<span>{{ formatDate(new Date(user.logout_time)) }}</span></div>
          </div>
        </div>

        <div class="login-logs-section">
          <div class="section-title">登入紀錄（最近一個月）</div>
          <div v-if="user.login_logs && user.login_logs.length > 0" class="login-logs-list">
            <div 
              v-for="log in user.login_logs" 
              :key="log.id" 
              class="login-log-item"
              @click="viewLoginLogDetail(log.id)"
            >
              <div class="log-main-info">
                <div class="log-time">
                  <div class="login-time">登入：{{ formatDateTime(new Date(log.login_time)) }}</div>
                  <div v-if="log.logout_time" class="logout-time">登出：{{ formatDateTime(new Date(log.logout_time)) }}</div>
                  <div v-else class="logout-time active">登入中</div>
                </div>
                <div class="log-device-info">
                  <div v-if="log.device_info" class="device-summary">
                    {{ log.device_info.manufacturer || '' }} {{ log.device_info.model || '' }}
                  </div>
                  <div v-else class="device-summary">未知裝置</div>
                  <div v-if="log.ip_address" class="ip-address">IP: {{ log.ip_address }}</div>
                </div>
              </div>
              <div class="log-duration" v-if="log.session_duration">
                <span class="duration-text">{{ log.session_duration }}分鐘</span>
              </div>
              <div class="log-arrow">
                <a-icon type="right" />
              </div>
            </div>
          </div>
          <div v-else class="no-logs">
            暫無登入紀錄
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {message, Modal} from "ant-design-vue";

export default {
  name: 'AccountCard',
  inject: ['getUserData', 'clearUserData'],
  data() {
    return {
      user: {}
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {

      const token = localStorage.getItem('token');
      this.$axios.get(`/api/users/${this.$route.params.id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then(response => {
        this.user = response.data.data;
        console.log(response.data.data);
      }).catch(error => {
        console.error(error);
      });
    },
    onDelete() {

      Modal.confirm({
        title: '刪除帳號',
        content: '確認要刪除此帳號嗎？',
        okText: '刪除',
        okType: 'primary',
        okButtonProps: {
          danger: true
        },
        cancelText: '取消',
        onOk: () => {

          const token = localStorage.getItem('token');
          this.$axios.delete(`/api/users/${this.$route.params.id}`, {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }).then(response => {
            console.log(response.data.data);
            message.success('已將帳號刪除');
            this.$router.go(-1)

          }).catch(error => {
            console.error(error.status);
            if (error.status === 401) {
              this.$router.push('/login');
            }
          });
        },
      });
    },
    onSuspend() {

      const token = localStorage.getItem('token');
      const isActive = this.user.is_active
      this.$axios.patch(`/api/users/${this.$route.params.id}`, {
        is_active: !isActive
      }, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then(response => {
        console.log(response.data.data);
        this.fetchData();
        message.success(`已將帳號${isActive ? "停權" : "復權"}`);
      }).catch(error => {
        console.error(error.status);
        if (error.status === 401) {
          this.$router.push('/login');
        }
      });
    },
    onEdit() {
      this.$router.push(`/account/edit/${this.$route.params.id}`);
    },
    viewLoginLogDetail(logId) {
      this.$router.push(`/login-log-detail/${logId}`);
    },
    formatDate(date) {
      try {
        return new Intl.DateTimeFormat("en-CA", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        }).format(date);
      } catch (e) {
        return ""
      }
    },
    formatDateTime(date) {
      try {
        return new Intl.DateTimeFormat("zh-TW", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        }).format(date);
      } catch (e) {
        return ""
      }
    },
  }
};
</script>

<style scoped>
.card-content {
  background-color: white;
  border-radius: 8px;
  margin-top: 16px;
  max-width: 800px;
}

.header {
  display: flex;
  justify-content: space-between;
  padding: 28px 32px;
}

hr {
  border: 1px solid #e0e0e0;
}

.user-info h3 {
  font-size: 24px;
  margin: 0;
}

.user-info p {
  color: gray;
  margin: 0;
}

.buttons button {
  margin-left: 10px;
}

.details {
  padding: 28px 32px;
}

.details {
  display: grid;
  grid-template-columns: repeat(2, auto);
  gap: 8px 16px;
}

.detail-row {
  display: contents;
}

.detail-row div {
  text-align: left;
  color: #999999;
  size: 18px;
}

.detail-row div span {
  color: #333333;
}

.login-logs-section {
  padding: 0 32px 28px 32px;
  border-top: 1px solid #e0e0e0;
}

.section-title {
  color: #999999;
  font-size: 18px;
  margin: 16px 0 12px 0;
  font-weight: 500;
}

.login-logs-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.login-log-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.login-log-item:hover {
  border-color: #1890ff;
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.1);
}

.log-main-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.log-time {
  display: flex;
  gap: 16px;
  align-items: center;
}

.login-time, .logout-time {
  font-size: 14px;
  color: #666;
}

.logout-time.active {
  color: #52c41a;
  font-weight: 500;
}

.log-device-info {
  display: flex;
  gap: 16px;
  align-items: center;
}

.device-summary {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.ip-address {
  font-size: 12px;
  color: #999;
  background: #f5f5f5;
  padding: 2px 8px;
  border-radius: 4px;
}

.log-duration {
  margin: 0 16px;
}

.duration-text {
  font-size: 12px;
  color: #1890ff;
  background: #f0f8ff;
  padding: 4px 8px;
  border-radius: 4px;
}

.log-arrow {
  color: #ccc;
  font-size: 16px;
}

.no-logs {
  text-align: center;
  color: #999;
  padding: 32px;
  font-style: italic;
}
</style>
